import { observer } from 'mobx-react-lite'
import { match } from '@/utils/pattern-match-util'
import { type CreateOCRScopeJobsViewModel } from './CreateOCRScopeJobsViewModel'
import {
  CreateOCRScopeJobsDialog,
  CreateOCRScopeJobsDialogManageDocumentsStep,
  CreateOCRScopeJobsDialogScopeNewJobsStep,
  CreateOCRScopeJobsDialogSelectedFile,
} from '@/features/jobs/scoping/components/CreateOCRScopeJobsDialog'
import { ScopeNewJobsContentContainer } from './ScopeNewJobsContentContainer'
import { NonAdminScopeNewJobsContentContainer } from './NonAdminScopeNewJobsContentContainer'

export interface CreateOCRScopeJobsDialogContainerProps {
  vm: CreateOCRScopeJobsViewModel
}

export const CreateOCRScopeJobsDialogContainer = observer(
  function CreateOCRScopeJobsDialogContainer({
    vm,
  }: CreateOCRScopeJobsDialogContainerProps) {
    const testId = 'create-ocr-scope-jobs-dialog'
    return (
      <CreateOCRScopeJobsDialog
        showing={vm.modal.showing}
        isPending={vm.submit.pending}
        onClose={vm.modal.close}
      >
        {match(vm.step, {
          ManageDocuments: () => (
            <CreateOCRScopeJobsDialogManageDocumentsStep
              selectedFilesCount={vm.selectedFilesCount}
              onAddFiles={vm.addFiles}
              onNext={vm.goToScopeNewJobs}
            >
              {vm.selectedFiles.map((file, index) => (
                <CreateOCRScopeJobsDialogSelectedFile
                  name={file.name}
                  onRemove={() => vm.removeFile(file)}
                  key={index}
                />
              ))}
            </CreateOCRScopeJobsDialogManageDocumentsStep>
          ),
          ScopeNewJobs: () => (
            <CreateOCRScopeJobsDialogScopeNewJobsStep
              submitLabel={
                vm.scopeJobMode === 'Collectively' && vm.selectedFilesCount > 1
                  ? `Scope ${vm.selectedFilesCount} Jobs`
                  : 'Scope This Job'
              }
              isSubmitPending={vm.submit.pending}
              isDisabled={vm.disabled}
              onBack={vm.goToManageDocuments}
              onSubmit={vm.submit}
            >
              {vm.isNonAdminUser ? (
                <NonAdminScopeNewJobsContentContainer vm={vm} testId={testId} />
              ) : (
                <ScopeNewJobsContentContainer vm={vm} testId={testId} />
              )}
            </CreateOCRScopeJobsDialogScopeNewJobsStep>
          ),
        })}
      </CreateOCRScopeJobsDialog>
    )
  },
)
